






import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { Config } from "@/shared/config";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { Home } from "@/shared/route-names";
import { SamlError } from "@/employee/route-names";
import * as datadog from "@/shared/datadog";
import { useSamlStore } from "@/employee/store/saml";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    GenericLoadingSpinner
  }
})

export default class Saml extends Vue {
  samlStore = useSamlStore();
  userStore = useUserStore();

  @Prop()
  provider: string;

  @Prop()
  code: string;

  @Prop()
  errorDescription: string;

  @Prop()
  error: string;

  mounted () {
    if (this.provider) {
      this.samlStore.updateProvider(this.provider);
      this.redirectToSso(this.provider);
    } else if (this.errorDescription && this.errorDescription.includes("Already found an entry for username")) {
      this.redirectToSso(this.samlStore.storedProvider);
      // https://forums.aws.amazon.com/thread.jspa?threadID=267154&start=0&tstart=0
    } else if (this.code) {
      this.samlStore.getTokens(this.code).catch(err => {
        this.$router.push({ name: SamlError });
      });
    } else {
      const message = (this.error || this.errorDescription) ? `${this.error} ${this.errorDescription}`
          : "Error in SAML auth";
      datadog.log(message, { fullPath: this.$route.fullPath }, "error");
      this.$router.push({ name: SamlError });
    }
  }

  @Watch("userStore.loggedIn")
  watchLoggedIn (): void {
    if (this.userStore.loggedIn) {
      this.$router.push({ name: Home });
    }
  }

  redirectToSso (provider: string) {
    const clientId = Config.Cognito.ClientId;
    const domain = Config.Cognito.UserPoolDomain;
    const hostName = window.location.origin;

    const ssoUrl = `https://${domain}.auth.us-east-1.amazoncognito.com/oauth2/authorize?identity_provider=${provider}&redirect_uri=${hostName}/saml.html&response_type=CODE&client_id=${clientId}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`;
    window.location.href = ssoUrl;
  }
}
